import React from 'react';
import MediaQuery from 'react-responsive';
import AwardsOverlayCard from 'components/atoms/awardOverlayCard';
import { chunk } from 'lodash';
import './styles.scss';

const AwardsOverlay = props => {
  const awardData = props.data;
  let awards = chunk(awardData, 3);
  return (
    <div className={'main-div'}>
      <MediaQuery minDeviceWidth={576}>
        {awards.map((award, idx) => {
          return <AwardsOverlayCard cardData={award} />;
        })}
      </MediaQuery>
      <MediaQuery maxDeviceWidth={575.6} />
    </div>
  );
};
export default AwardsOverlay;
